import { POLARITY } from '../../../config/constants.js';

/**
 * The resonance release volley (BULLET-HELL.md §D7) — the absorbed fire handed
 * back as homing shots.
 *
 * Extracted from Game for the same reason `bulletCancel.js` was: the geometry
 * and the pricing are the whole mechanic and are worth testing on their own,
 * while the parts that need the running game (which pool, what is nearest,
 * whether there is anything to shoot at all) stay in the one file that holds
 * them.
 *
 * Fans `POLARITY.releaseShots` homing projectiles out of the player toward
 * `target`. The fan matters: all six on the same line would arrive as one hit
 * and look like a single big shot, where a spread visibly *converges*, which is
 * the image the mechanic wants — the tones you swallowed coming back out.
 *
 * Returns the number of shots fired (0 with no target, so the caller can hand
 * the stacks back rather than spending a release on an empty room).
 */
export function fireRelease({ player, target, pool, damageMultiplier = 1 }) {
  if (!player || !target || !pool) return 0;
  const damage = POLARITY.releaseDamage * damageMultiplier;
  const aim = Math.atan2(target.y - player.y, target.x - player.x);
  const shots = POLARITY.releaseShots;
  for (let i = 0; i < shots; i++) {
    const t = shots === 1 ? 0.5 : i / (shots - 1);
    const angle = aim + (t - 0.5) * POLARITY.releaseSpread;
    pool.fire({
      x: player.x,
      y: player.y,
      vx: Math.cos(angle) * POLARITY.releaseSpeed,
      vy: Math.sin(angle) * POLARITY.releaseSpeed,
      radius: 2.4,
      damage,
      hits: 1,
      lifetime: POLARITY.releaseLifetime,
      color: POLARITY.color,
      homing: true,
      turnRate: POLARITY.releaseTurnRate,
      target,
    });
  }
  return shots;
}
